import { Injectable, signal } from '@angular/core';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class TabService {

  
  constructor() { }

  tabs = { EXPLORER: 0, FILES: 1, DEVELOPER: 2, COMMUNITY: 3, ACCOUNT: 4 };
  bottomNavTabs = { RESULTS: 0, JOBS: 1, MESSAGES: 2 };
  communityTabs = { GROUPS: 0, PROJECTS: 1, DATABASKETS: 2, JOBS: 3, SERVICES: 4, FILES: 5};
  explorerSideNavs = { SEARCH: 0, SERVICES: 1, WORKSPACE: 2 };
  developerSideNavs = { SERVICES: 0 };
  filesSideNavs = { SEARCH: 0, UPLOAD: 1 };

  selectedProcess:any = undefined;
  selectedProcessDetails:any = undefined;
  selectedProcessInputs = signal<ProcessInput[]>([]);

  getTabs(): any {
      return this.tabs; //angular.copy(tabs);
  };
  getExplorerSideNavs(): any {
      return this.explorerSideNavs; //angular.copy(explorerSideNavs);
  };
  getBottomNavTabs(): any {
      return this.bottomNavTabs; //angular.copy(bottomNavTabs);
  };
  getCommunityNavTabs(): any {
      return this.communityTabs; //angular.copy(communityTabs);
  };
  getDeveloperSideNavs(): any {
      return this.developerSideNavs; //angular.copy(developerSideNavs);
  };

  getFilesSideNavs(): any {
      return this.filesSideNavs; //angular.copy(filesSideNavs);
  };

  /** PRESERVE USER SELECTIONS **/
  navInfo = {
      explorer: {
          activeTab: this.tabs.EXPLORER,
          sideViewVisible: false,
          activeSideNav: undefined,
          activeBottomNav: this.bottomNavTabs.RESULTS,
          resultTabNameExtention: '',
          bottomViewVisible: signal(false)
      },
      files: {
          activeTab: this.tabs.FILES,
          sideViewVisible: true,
          activeSideNav: this.filesSideNavs.SEARCH,
          activeBottomNav: undefined,
          bottomViewVisible: signal(false)
      },
      developer: {
          activeTab: this.tabs.DEVELOPER,
          sideViewVisible: true,
          activeSideNav: this.developerSideNavs.SERVICES,
          activeBottomNav: undefined,
          bottomViewVisible: signal(false)
      },
      community: {
          activeTab: this.tabs.COMMUNITY,
          sideViewVisible: true,
          activeSideNav: this.communityTabs.GROUPS,
          activeBottomNav: undefined,
          bottomViewVisible: signal(false)
      },
      admin: {
          sideViewVisible: false,
          bottomViewVisible: signal(false)
      }
  };
  /** END OF PRESERVE USER SELECTIONS **/

  showExplorerSidebarArea(): void {
    this.navInfo.explorer.sideViewVisible = true;
  }

  hideExplorerSidebarArea(): void {
    this.navInfo.explorer.activeSideNav = undefined;
    this.navInfo.explorer.sideViewVisible = false;
  };

  toggleExplorerSidebar(tab: any): void {
    if(this.navInfo.explorer.activeSideNav === tab) {
        this.hideExplorerSidebarArea();
    } else {
      this.navInfo.explorer.activeSideNav = tab;
        this.showExplorerSidebarArea();
    }
  };

  showBottomView(): void {
    this.navInfo.explorer.bottomViewVisible.set(true);
  };

  toggleBottomView(): void {
    this.navInfo.explorer.bottomViewVisible.set(!this.navInfo.explorer.bottomViewVisible());
  };

  toggleBottomViewMessages(): void {
    if (this.navInfo.explorer.bottomViewVisible && this.navInfo.explorer.activeBottomNav == this.bottomNavTabs.MESSAGES) {
        this.navInfo.explorer.bottomViewVisible.set(false);
    } else {
        this.navInfo.explorer.activeBottomNav = this.bottomNavTabs.MESSAGES;
        this.navInfo.explorer.bottomViewVisible.set(true);
    }
  }

  showBottomViewResults(): void {
    this.navInfo.explorer.activeBottomNav = this.bottomNavTabs.RESULTS;
    this.navInfo.explorer.bottomViewVisible.set(true);
  }

  showBottomViewJobs(): void {
    this.navInfo.explorer.activeBottomNav = this.bottomNavTabs.JOBS;
    this.navInfo.explorer.bottomViewVisible.set(true);
  }

  showBottomViewMessages(): void {
    this.navInfo.explorer.activeBottomNav = this.bottomNavTabs.MESSAGES;
    this.navInfo.explorer.bottomViewVisible.set(true);
  }

  getOpenedBottombar(): any {
    if(this.navInfo.explorer.bottomViewVisible()){
        return this.navInfo.explorer.activeBottomNav;
    } else {
        return undefined;
    }
  };
}

export interface ProcessInput {
  tag: string;
  title: string;
  description: string;
  maxOccurs: number|undefined;
  schema: any;
  fieldids: string[];
  sortOrder: number;
}